import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { createActions } from '@manager-base/app-base/config/data-access';

const actions = {
    getPaymentInfo: {
        method: 'GET',
        url: `${BASE_PATH_API}/payments/:id`
    },
    saveReversedPayments: {
        method: 'POST',
        url: `${BASE_PATH_API}/reversedpayments`
    },
    getPaymentBankAccount: {
        method: 'GET',
        url: `${BASE_PATH_API}/payments/:paymentId/bankAccount`
    },
    savePayment: {
        method: 'POST',
        url: `${BASE_PATH_API}/payments`
    },
    getPaymentReceiptSetting: {
        method: 'GET',
        url: `${BASE_PATH_API}/communicationsettings/paymentReceipt`
    },
    updatePayment: {
        method: 'PUT',
        url: `${BASE_PATH_API}/payments/:journalId`
    },
    deletePayment: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/payments/:journalId`
    },
    getReversedPayments: {
        method: 'GET',
        url: `${BASE_PATH_API}/reversedpayments/:id`
    },
    deleteReversedPayments: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/reversedpayments/:id`
    },
    getUnReversedPayments: {
        method: 'GET',
        url: `${BASE_PATH_API}/UnreversedPayments/:id`
    },
    getBillPaymentsV2: {
        method: 'GET',
        url: `${BASE_PATH_API}/payments/v2/bills/:billId?propertyEntityId=:propertyEntityId&type=:type&unitType=:unitType&unitIds=:unitIds`
    }
};

export function PaymentsApi() {
    const service = createActions(actions);
    
    service.getPrintPaymentUrl = function getPrintPaymentUrl(journalId) {
        return `${BASE_PATH_API}/payments/${journalId}/printreceipt?inline=false`;
    };
    
    return service;
}
PaymentsApi.$inject = [];
